<template>
    <Modal2
        design="v3"
        :show-footer="true"
        :show-title="true"
        title="WhatsApp Liste Mesajı Ayarları"
        ok-text="Kaydet"
        cancel-text="İptal"
        @ok="handleSave"
        @cancel="handleCancel"
        class-name="whatsapp-settings-modal"
    >
        <div class="whatsapp-settings-form">
            <div class="info-banner">
                <span class="material-icons">info</span>
                <span
                    >3'ten fazla buton olduğunda WhatsApp liste mesajı olarak gönderilir. Bu ayarları
                    özelleştirebilirsiniz.</span
                >
            </div>

            <div class="setting-field">
                <div class="field-header">
                    <label>Liste Buton Başlığı</label>
                    <a-tooltip placement="topRight">
                        <template #title>
                            <div class="tooltip-content">
                                <p>Kullanıcının listeyi açmak için tıklayacağı buton metni</p>
                                <p class="limit-info">Maksimum: 20 karakter</p>
                                <img src="https://static.supsis.live/common/whatsapp/waba-list-button-min.png" alt="Global Button" />
                            </div>
                        </template>
                        <span class="material-icons help-icon">help_outline</span>
                    </a-tooltip>
                </div>
                <input
                    type="text"
                    v-model="localSettings.globalButtonTitle"
                    placeholder="Seçenekler"
                    maxlength="20"
                    class="settings-input"
                />
                <span class="char-count">{{ (localSettings.globalButtonTitle || "").length }}/20</span>
            </div>

            <div class="setting-field">
                <div class="field-header">
                    <label>Bölüm Başlığı</label>
                    <a-tooltip placement="topRight">
                        <template #title>
                            <div class="tooltip-content">
                                <p>Liste içindeki bölüm başlığı</p>
                                <p class="limit-info">Maksimum: 24 karakter</p>
                                <img src="https://static.supsis.live/common/whatsapp/waba-list-button-min.png" alt="Section Title" />
                            </div>
                        </template>
                        <span class="material-icons help-icon">help_outline</span>
                    </a-tooltip>
                </div>
                <input
                    type="text"
                    v-model="localSettings.sectionTitle"
                    placeholder="Seçim yapınız"
                    maxlength="24"
                    class="settings-input"
                />
                <span class="char-count">{{ (localSettings.sectionTitle || "").length }}/24</span>
            </div>

            <div class="setting-field">
                <div class="field-header">
                    <label>Bölüm Açıklaması</label>
                    <a-tooltip placement="topRight">
                        <template #title>
                            <div class="tooltip-content">
                                <p>Liste bölümü için açıklama metni</p>
                                <p class="limit-info">Maksimum: 72 karakter</p>
                                <img
                                    src="https://static.supsis.live/common/whatsapp/waba-list-button-min.png"
                                    alt="Section Subtitle"
                                />
                            </div>
                        </template>
                        <span class="material-icons help-icon">help_outline</span>
                    </a-tooltip>
                </div>
                <input
                    type="text"
                    v-model="localSettings.sectionSubTitle"
                    placeholder="Aşağıdaki seçeneklerden birini seçiniz"
                    maxlength="72"
                    class="settings-input"
                />
                <span class="char-count">{{ (localSettings.sectionSubTitle || "").length }}/72</span>
            </div>

            <div class="setting-field">
                <div class="field-header">
                    <label>Alt Bilgi (Footer)</label>
                    <a-tooltip placement="topRight">
                        <template #title>
                            <div class="tooltip-content">
                                <p>Mesajın altında görünecek isteğe bağlı metin</p>
                                <p class="limit-info">Maksimum: 60 karakter</p>
                                <img src="https://static.supsis.live/common/whatsapp/waba-list-button-min.png" alt="Footer" />
                            </div>
                        </template>
                        <span class="material-icons help-icon">help_outline</span>
                    </a-tooltip>
                </div>
                <input
                    type="text"
                    v-model="localSettings.footer"
                    placeholder="İsteğe bağlı alt bilgi"
                    maxlength="60"
                    class="settings-input"
                />
                <span class="char-count">{{ (localSettings.footer || "").length }}/60</span>
            </div>
        </div>
    </Modal2>
</template>

<script>
import _ from "lodash";
import Modal2 from "../../../../../../../components/common/Modal2.vue";

export default {
    name: "WhatsappListSettingsModal",
    components: { Modal2 },
    props: {
        value: {
            type: Object,
            default: () => ({
                globalButtonTitle: "",
                sectionTitle: "",
                sectionSubTitle: "",
                footer: "",
            }),
        },
    },
    data() {
        return {
            localSettings: _.cloneDeep(this.value),
        };
    },
    methods: {
        handleSave() {
            this.$emit("save", this.localSettings);
        },
        handleCancel() {
            this.$emit("cancel");
        },
    },
    watch: {
        value: {
            handler(newVal) {
                this.localSettings = _.cloneDeep(newVal);
            },
            deep: true,
        },
    },
};
</script>

<style lang="scss" scoped>
.whatsapp-settings-form {
    display: flex;
    flex-direction: column;
    gap: 20px;

    .info-banner {
        display: flex;
        align-items: center;
        gap: 10px;
        padding: 12px;
        background: #e7f7ef;
        border-left: 3px solid #25d366;
        border-radius: 4px;
        font-size: 13px;
        color: #333;

        .material-icons {
            font-size: 20px;
            color: #25d366;
        }
    }

    .setting-field {
        position: relative;

        .field-header {
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-bottom: 8px;

            label {
                font-size: 13px;
                font-weight: 600;
                color: #333;
                margin: 0;
            }

            .help-icon {
                font-size: 18px;
                color: #bbb;
                cursor: help;
                transition: color 0.2s;

                &:hover {
                    color: #25d366;
                }
            }
        }

        .settings-input {
            width: 100%;
            padding: 10px 12px;
            padding-right: 50px;
            font-size: 14px;
            border: 1px solid #d9d9d9;
            border-radius: 6px;
            transition: all 0.3s;

            &:hover {
                border-color: #40a9ff;
            }

            &:focus {
                outline: none;
                border-color: #25d366;
                box-shadow: 0 0 0 2px rgba(37, 211, 102, 0.1);
            }

            &::placeholder {
                color: #bfbfbf;
            }
        }

        .char-count {
            position: absolute;
            right: 12px;
            bottom: 11px;
            font-size: 11px;
            color: #999;
            pointer-events: none;
            background: white;
            padding: 0 4px;
        }
    }
}

::v-deep .tooltip-content {
    text-align: center;

    p {
        margin: 0 0 8px 0;
        color: white;
        font-size: 13px;
    }

    .limit-info {
        font-size: 11px;
        opacity: 0.9;
        margin-bottom: 12px;
    }

    img {
        max-width: 300px;
        width: 100%;
        border-radius: 6px;
        margin-top: 8px;
        border: 1px solid rgba(255, 255, 255, 0.2);
    }
}
</style>
